export default __webpack_public_path__ + "static/homepage_1-776bfb9271d007beea513a3ee3b86b1c.png";